import script from "./LanguageSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSelector.vue?vue&type=style&index=0&id=6f7a41de&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f7a41de"]])

export default __exports__